// api.js
import axios from 'axios';
import { showSecureModal } from './utils/modalManager';

const baseURL = process.env.REACT_APP_API_URL;
const api = axios.create({ baseURL });

const handleLogout = () => {
  sessionStorage.clear();
  // localStorage.clear();
  localStorage.removeItem("unreadCounts");
  localStorage.removeItem("totalUnreadCount");
  window.location.href = '/login';
};

// Enhanced request interceptor
api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Add user ID to all mining requests
  if (config.url.includes('/mining/') && user?.user_id) {
    config.data = {
      ...config.data,
      user_id: user.user_id
    };
  }
  
  return config;
}, error => Promise.reject(error));

// Enhanced response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const errorMessage = error.response.data?.error || '';
      if (errorMessage.includes('Token is not valid') || 
          errorMessage.includes('No token, authorization denied')) {
        showSecureModal({
          title: 'Session Expired',
          message: 'Your session has expired or is no longer valid. Please log in again to continue.',
          onClose: handleLogout
        });
      }
    }
    return Promise.reject(error);
  }
);

// api.js
export const miningGameAPI = {
  getGameState: () => api.get('/mining/state'),
  handleTap: () => api.post('/mining/tap'),
  buyUpgrade: (upgradeType) => api.post(`/mining/upgrade/${upgradeType}`),
  activateBoost: (boostType) => api.post(`/mining/boost/${boostType}`),
  claimDailyReward: () => api.post('/mining/daily-reward'),
  getLeaderboard: () => api.get('/mining/leaderboard'),
  joinGame: () => api.post('/mining/join'),
  syncActions: (data) => api.post('/mining/sync/actions', data),
};

export default api;